import React from 'react'
import Footer from '../components/layout/Footer'
import Navbar from './Navbar'


const AboutUs = () => {
  return (
    <div className=''>
      <Navbar/>
        <div className='w-full lg:px-32 md:px-20  px-2 py-12'>
          <div className='py-2'>
          <h1 className='lg:text-3xl md:text-2xl text-xl  font-semibold p-2'>ABOUT US</h1>
          <h2 className='text-sm text-gray-700 p-2'>India's most convenient online grocery channel</h2>
          <p className=' p-2 text-sm text-gray-700 '>Reliance Fresh and Smart makes your grocery shopping even simpler. No more hassles of sweating it out in crowded markets, grocery shops & supermarkets - now shop from the comfort of your home; office or on the move.</p>
          <p className=' p-2 text-sm text-gray-700 '>We offer you convenience of shopping everything that you need for your home - be it fresh fruits & vegetables, rice, dals, oil, packaged food, dairy item, frozen, pet food, household cleaning items & personal care products from a single virtual store.</p>
          </div>

          
          <div className='h-24 border border-transparent border-t-gray-300'>
<p className=' p-2 text-sm text-gray-700' >AppnaApp is an online selling channel (format) of Reliance Retail Limited. Visit <a className='text-sky-600 cursor-pointer'>www.appnaapp.com</a> for details.</p>
          </div>
        </div>
        <Footer/>

    </div>
  )
}

export default AboutUs